import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { FormattedMessage } from 'react-intl';


const LinkAdAccountAnimation = (props) => {
  return (
    <>
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress sx={{ mx: 'auto' }} />
      </Box>

      <Typography align="center" sx={{ mt: '32px' }}><FormattedMessage id="addAccount.modal.authorizationInProgress" /></Typography>
    </>
  )
}

export default LinkAdAccountAnimation;